import { render, staticRenderFns } from "./ModalOkCancel.vue?vue&type=template&id=a7f2260c&"
import script from "./ModalOkCancel.vue?vue&type=script&lang=js&"
export * from "./ModalOkCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports